var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CToaster',{attrs:{"autohide":3000}},_vm._l((_vm.toasts),function(info,index){return _c('CToast',{key:`${info.header}-${index}`,attrs:{"show":true,"header":info.header,"color":info.color}},[_vm._v(" "+_vm._s(info.message)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }